// extracted by mini-css-extract-plugin
export var aiPolicy = "d_q";
export var icon = "d_n";
export var prevSection = "d_m";
export var rowGap = "d_r";
export var section = "d_j";
export var separator = "d_k";
export var table = "d_h";